module.exports = fox._r("images/default/gift-89.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/default/gift-89.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/default/gift-89.png
// module id = 290
// module chunks = 4